import { Config } from '@adornis/config/config.js';

export const config = new Config('digitale-helden-marketing', {
  INSTAGRAM_USER_ID: { env: true, client: false, required: true, name: 'INSTAGRAM_USER_ID' },
  INSTAGRAM_API_TOKEN: { env: true, client: false, required: true, name: 'INSTAGRAM_API_TOKEN' },
});
